import { AlertOctagon, CheckCircle2, Clock, Loader, Wallet } from "lucide-react"
import type { ComponentType } from "react"

/**
 * Etiqueta de estatus operativo.
 *
 * **Once estatus, cinco colores.** Once colores distintos no se distinguen: se
 * convierten en ruido y nadie los aprende. Se agrupan en cinco semánticas (§7).
 *
 * Y tres cosas que no son decoración:
 * - **El nombre del estado se escribe siempre.** El color nunca es el único
 *   portador de significado (WCAG 1.4.1).
 * - **Cada grupo lleva un icono distinto**, para que se distingan en escala de
 *   grises y con daltonismo.
 * - Los nombres son literalmente los del 2.0. No se traducen ni se «mejoran»
 *   mientras los dos sistemas convivan.
 */

export type Estatus =
  | "POR_LLEGAR"
  | "POR_REGISTRO"
  | "RECONOCIMIENTO"
  | "DETENIDO"
  | "VALIDADO"
  | "POR_DESPACHO"
  | "PENDIENTE_APROBACION_DESPACHO"
  | "DESPACHADO"
  | "LIQUIDADO"
  | "POR_COBRAR"
  | "COBRADO"

type Grupo = "transito" | "proceso" | "detenido" | "completado" | "cobrar"

const GRUPO_DE: Record<Estatus, Grupo> = {
  POR_LLEGAR: "transito",
  POR_REGISTRO: "transito",
  RECONOCIMIENTO: "proceso",
  VALIDADO: "proceso",
  POR_DESPACHO: "proceso",
  PENDIENTE_APROBACION_DESPACHO: "proceso",
  DETENIDO: "detenido",
  DESPACHADO: "completado",
  LIQUIDADO: "completado",
  COBRADO: "completado",
  POR_COBRAR: "cobrar",
}

const ESTILO: Record<
  Grupo,
  { color: string; fondo: string; icono: ComponentType<{ size?: number }> }
> = {
  transito: { color: "var(--fg-muted)", fondo: "var(--surface-elevated)", icono: Clock },
  proceso: { color: "var(--info)", fondo: "transparent", icono: Loader },
  detenido: { color: "var(--destructive)", fondo: "transparent", icono: AlertOctagon },
  completado: { color: "var(--success)", fondo: "transparent", icono: CheckCircle2 },
  cobrar: { color: "var(--warning)", fondo: "transparent", icono: Wallet },
}

export function BadgeEstatus({ estatus }: { estatus: Estatus }) {
  const { color, fondo, icono: Icono } = ESTILO[GRUPO_DE[estatus]]
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-[var(--radius-control)] border px-2 py-0.5 text-xs font-medium"
      style={{ color, backgroundColor: fondo, borderColor: "var(--border)" }}
    >
      <Icono size={14} aria-hidden="true" />
      {estatus.replaceAll("_", " ")}
    </span>
  )
}
